export enum CollectionRequestStatus {
  SCHEDULED_FOR_NOTIFICATION = 'SCHEDULED_FOR_NOTIFICATION',
  SCHEDULED = 'SCHEDULED',
  IN_REALIZATION = 'IN_REALIZATION',
  FEEDBACK_ALLOWED = 'FEEDBACK_ALLOWED',
  COMPLETED = 'COMPLETED',
  MISSED = 'MISSED',
}
